import MuiPopover, { PopoverProps as MuiPopoverProps } from "@mui/material/Popover";
import * as React from "react";

type PopoverProps = {
  anchorOrigin?: MuiPopoverProps["anchorOrigin"];
  className?: string;
  contentEl: React.ReactNode;
  triggerEl: React.ReactNode;
};

export default function Popover({
  anchorOrigin = { horizontal: "left", vertical: "bottom" },
  className,
  contentEl,
  triggerEl,
}: PopoverProps) {
  const [anchorEl, setAnchorEl] = React.useState<HTMLDivElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div className={className}>
      <div aria-describedby={id} onClick={handleClick}>
        {triggerEl}
      </div>
      <MuiPopover
        anchorEl={anchorEl}
        anchorOrigin={anchorOrigin}
        disableRestoreFocus
        id={id}
        onClose={handleClose}
        open={open}
      >
        {contentEl}
      </MuiPopover>
    </div>
  );
}
